import PropTypes from "prop-types";
import AddressCard from "@shared/AddressCard";
// eslint-disable-next-line import/no-unresolved
import GoogleMap from "@shared/v2/GoogleMap/GoogleMap";
import Button from "../../shared/v2/Button";
import IconButton from "../../shared/v2/IconButton";
import { PlusSolidV6, TrashAltSolidV3 } from "../../shared/v2/Icomoon";
import Card from "./Card";
import DisplayRow from "./DisplayRow";
import EditableTitle from "./EditableTitle";

const OfficeCard = ({ model, setValue, saveValue, onAdd, onRemove, editable, SECTIONS, onEditAddress }) => {
  return (
    <Card
      title={
        <EditableTitle
          value={model.name || "Office"}
          onChange={(v) => setValue("name", v)}
          onBlur={() => saveValue("name", model.name)}
          editable={editable}
        />
      }
      action={
        <div className="tw-justify-end tw-flex-1 tw-flex tw-items-center">
          {onRemove && (
            <IconButton schema="misc-trash" size="small" onClick={() => onRemove(model)}>
              <TrashAltSolidV3 size="m" />
            </IconButton>
          )}
          {onAdd && (
            <Button
              className="tw-whitespace-nowrap tw-ml-[8px]"
              schema="secondary"
              size="small"
              onClick={onAdd}
            >
              + Office
            </Button>
          )}
        </div>
      }
    >
      {SECTIONS.map((sec) => (
        <DisplayRow
          key={sec.key}
          title={sec.title}
          editable={sec.editable}
          value={model[sec.key]}
          displayValue={sec.displayValue}
          onChange={(val) => {
            setValue(sec.key, val);
          }}
          onSave={(val) => saveValue(sec.key, val)}
          Comp={sec.comp}
          isDD={sec.isDD}
        />
      ))}
      <hr className="tw-my-[24px] tw-border-t tw-border-gray-10" />

      {model.street_address ? (
        <div className="tw-flex tw-items-start tw-justify-between tw-overflow-x-hidden">
          <div className="tw-flex-1">
            <div className="tw-text-14d tw-mb-8px tw-font-bold">Street Address</div>
            <AddressCard
              streetAddress={model.street_address}
              secondaryAddress={model.secondary_address}
              cityStateZip={`${model.city}, ${model.locality} ${model.postal_code}`}
              country={model.country}
              standardized={model?.standardized}
              containerClassName="tw-mt-[-8px]"
            />
            <Button schema="secondary" className="tw-mt-[16px]" onClick={() => onEditAddress()}>
              Edit Address
            </Button>
          </div>
          <div className="tw-h-[156px] tw-w-[297px] tw-flex-shrink-0 tw-overflow-hidden tw-rounded-[8px] tw-bg-white tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-10">
            {model.lat && model.long && (
              <GoogleMap
                enableTerraCtrl={false}
                mapProps={{ center: { lat: model.lat, lng: model.long }, zoom: 14 }}
              />
            )}
          </div>
        </div>
      ) : (
        <div className="tw-py-[52px] tw-flex tw-flex-col tw-items-center tw-gap-12px">
          <div>No address on record for this office.</div>
          <Button size="medium" schema="secondary" onClick={onEditAddress}>
            <div className="tw-flex tw-items-center tw-gap-6px">
              <PlusSolidV6 />
              <span>Add Address</span>
            </div>
          </Button>
        </div>
      )}
    </Card>
  );
};

export const OFFICE_PROPS = {
  model: PropTypes.shape({
    account_offices: PropTypes.arrayOf(PropTypes.shape()),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    fax: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    address_attributes: PropTypes.shape(),
    address: PropTypes.shape(),
  }).isRequired,
  setValue: PropTypes.func.isRequired,
  saveValue: PropTypes.func.isRequired,
};

OfficeCard.propTypes = {
  ...OFFICE_PROPS,
  onEditAddress: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

OfficeCard.defaultProps = {
  onAdd: null,
  onRemove: null,
};

export default OfficeCard;
